import { render, staticRenderFns } from "./GeneUpgrade.vue?vue&type=template&id=23eb3f08"
import script from "./GeneUpgrade.vue?vue&type=script&lang=js"
export * from "./GeneUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports